const DEFAULT_PROD_API = "https://9fb52e22.ielts-boardgame.pages.dev";

const normalizeBaseUrl = (url) => {
  if (!url) {
    return "";
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return "";
  }

  const withoutTrailingSlash = trimmed.endsWith("/")
    ? trimmed.slice(0, -1)
    : trimmed;

  return withoutTrailingSlash.endsWith("/api")
    ? withoutTrailingSlash.slice(0, -4)
    : withoutTrailingSlash;
};

const resolveApiBaseUrl = () => {
  const envUrl = normalizeBaseUrl(process.env.REACT_APP_API_URL);
  const isBrowser = typeof window !== "undefined";

  if (isBrowser) {
    const { hostname, origin } = window.location;
    const normalizedOrigin = normalizeBaseUrl(origin);
    const isLocalhost =
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "[::1]";
    const isPagesDomain = hostname.endsWith(".ielts-boardgame.pages.dev");

    if (isPagesDomain) {
      return normalizedOrigin;
    }

    if (isLocalhost) {
      return envUrl || normalizeBaseUrl(DEFAULT_PROD_API);
    }

    if (!envUrl) {
      return normalizedOrigin;
    }
  }

  return envUrl || normalizeBaseUrl(DEFAULT_PROD_API);
};

const API_BASE_URL = resolveApiBaseUrl();

const buildEndpoint = (path) => {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;

  if (typeof window !== "undefined") {
    const currentOrigin = normalizeBaseUrl(window.location.origin);
    if (!API_BASE_URL || API_BASE_URL === currentOrigin) {
      return cleanPath;
    }
  }

  return API_BASE_URL ? `${API_BASE_URL}${cleanPath}` : cleanPath;
};

export const API_ENDPOINTS = {
  // 认证相关
  register: buildEndpoint("/api/auth/register"),
  login: buildEndpoint("/api/auth/login"),
  logout: buildEndpoint("/api/auth/logout"),
  user: buildEndpoint("/api/auth/user"),
  updateUser: buildEndpoint("/api/auth/update"),
  updateMembership: buildEndpoint("/api/auth/membership"),
  updateIeltsDeadline: buildEndpoint("/api/auth/ielts-deadline"),

  // 用户数据相关
  userProfile: buildEndpoint("/api/user/profile"),
  updateProfile: buildEndpoint("/api/user/profile"),

  // 游戏数据相关
  saveGameResult: buildEndpoint("/api/game/results"),
  getHistory: buildEndpoint("/api/game/history"),
  getStatistics: buildEndpoint("/api/game/statistics"),

  // 录音和转写相关
  saveRecording: buildEndpoint("/api/recording/save"),
  getTranscription: buildEndpoint("/api/recording/transcribe"),

  // 评分和分析相关
  getAnalysis: buildEndpoint("/api/analysis/score"),
  getSuggestions: buildEndpoint("/api/analysis/suggestions")
};

if (typeof window !== "undefined") {
  console.log("[API] Base URL resolved to:", API_BASE_URL || "(relative)");
  console.log("[API] Register endpoint:", API_ENDPOINTS.register);
  console.log("[API] Login endpoint:", API_ENDPOINTS.login);
}
